var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8067 3.75329C14.0667 4.01329 14.0667 4.43329 13.8067 4.69329L12.5867 5.91329L10.0867 3.41329L11.3067 2.19329C11.5667 1.93329 11.9867 1.93329 12.2467 2.19329L13.8067 3.75329ZM2 13.6666V11.64C2 11.5466 2.03333 11.4666 2.1 11.4L9.37333 4.12662L11.8733 6.62662L4.59333 13.9C4.53333 13.9666 4.44667 14 4.36 14H2.33333C2.14667 14 2 13.8533 2 13.6666Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b843275721ae0427f976a950fcb21475.svg";
export { ForwardRef as ReactComponent };